export const APP_EN = {
    'app.install.text': 'Use the app from your home screen: it opens in one tap, full screen.',
    'app.install.action': 'Install the app',
    'app.install.ios': 'To install the app: tap Share, then «Add to Home Screen».',
    'app.install.later': 'Not now',
    'app.update.text': 'A new version of the app is ready.',
    'app.update.action': 'Update now',
    // The page the app shows with no network (shell/src/pwa/build.ts writes it into the build).
    'app.offline.title': 'No connection',
    'app.offline.text': 'The app needs the network to show your data. Check the connection, then try again.',
    'app.offline.retry': 'Try again',
    // The product's name (owner, 2026-10-14): the brand beside the mark, the page title, the
    // installed app's name (the web app manifest). `app.short` is the name where a long one does not fit.
    'app.name': 'Enterprise Operating System',
    'app.short': 'EOS',
    // The shell's one toast (toast.tsx): the button that takes it away before its time.
    'toast.dismiss': 'Dismiss',
};
export const APP_AR = {
    'app.install.text': 'استخدم التطبيق من شاشتك الرئيسية: يفتح بلمسة واحدة وبملء الشاشة.',
    'app.install.action': 'ثبّت التطبيق',
    'app.install.ios': 'لتثبيت التطبيق: اضغط زر المشاركة، ثم «إضافة إلى الشاشة الرئيسية».',
    'app.install.later': 'ليس الآن',
    'app.update.text': 'نسخة جديدة من التطبيق جاهزة.',
    'app.update.action': 'حدّث الآن',
    'app.offline.title': 'لا اتصال بالشبكة',
    'app.offline.text': 'يحتاج التطبيق إلى الشبكة ليعرض بياناتك. تحقّق من الاتصال، ثم أعد المحاولة.',
    'app.offline.retry': 'أعد المحاولة',
    'app.name': 'نظام تشغيل المؤسسة',
    'app.short': 'EOS',
    'toast.dismiss': 'إخفاء',
};
//# sourceMappingURL=i18n-app.js.map